<div ngbDropdown class="d-inline-block">

      <div  id="dropdownBasic1" ngbDropdownToggle>
        <img class="drop-ico" src="assets/svg/drop_nav.svg">
        <span class="drop-ico-text">Nabídka</span>
      </div>

      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="mt-2">
        <a routerLink="register" ngbDropdownItem><i class="fa fa-user-plus" aria-hidden="true"></i> Registrovat se</a>
        <a routerLink="login" ngbDropdownItem><i class="fa fa-sign-in" aria-hidden="true"></i> Přihlásit se</a>
        <a routerLink="changepass" ngbDropdownItem><i class="fa fa-refresh" aria-hidden="true"></i> Změnit heslo</a>
        <a routerLink="page/privacy-policy" ngbDropdownItem><i class="fa fa-address-card"></i> Zpracování OÚ</a>
        <a routerLink="page/gdpr" ngbDropdownItem><i class="fa fa-lock"></i> GDPR</a>
      </div>

</div>
